import React, { useCallback, useContext, useState } from "react"
import {
    Text,
    View,
    StyleSheet,
    FlatList
} from "react-native"

import { AuthContext } from '../../contexts/auth/Store';
import { AnalyticsService } from "../../constants/Analytics";
import GridView from '../../components/product/GridView';
import Colors from "../../constants/Colors";
import { ICategory } from "../../interfaces/category";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import CategoryService from "../../services/CategoryService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { SafeJSONArray } from "../../constants/Utils";
import useMounted from "../../hooks/useMounted";
import cache from "../../utils/cache";

const analytics = new AnalyticsService();
const categoryService = new CategoryService();

function CategoryScreen() {
    const navigation = useNavigation();
    const isMounted = useMounted();
    const auth: any = useContext(AuthContext);

    const [state, setState] = useState<{ isLoading: boolean, hasError: any, data: any[] }>({
        isLoading: true,
        hasError: null,
        data: []
    })

    const nav_handler = (category: ICategory) => {
        if (category._id === 'category_001') {
            navigation.navigate('ProductExplore')
        } else {
            navigation.navigate('CategoryProduct', {
                id: category._id
            })
        }
    }

    const loadData = (reload: boolean = false): void => {
        // show loading view only when we specify reload
        isMounted.current && setState(prev => {
            return {
                ...prev,
                isLoading: reload,
                error: reload ? null : prev.hasError
            }
        })

        // load from storage while fetching from server
        AsyncStorage.getItem('active_categories')
            .then(data => {

                const categories = SafeJSONArray(data)
                isMounted.current && setState(prev => {
                    return {
                        ...prev,
                        isLoading: categories.length ? false : true,
                        error: null,
                        data: categories
                    }
                })
            })
            .catch(error => {
                isMounted.current && setState(prev => {
                    return {
                        ...prev,
                        isLoading: false,
                        hasError: error
                    }
                })
                analytics.logError(error)
            })

        // now load fresh burger from server or cache if available
        categoryService.fetchByStatus('active')
            .then(data => {
                const _data: any[] = [
                    { _id: 'category_001', upload: { path: '2020/11/default' }, name: 'All Products' },
                    ...data
                ]

                // categoryService.saveToCache(data)

                AsyncStorage.setItem('active_categories', JSON.stringify(_data))

                isMounted.current && setState(prev => {
                    return {
                        ...prev,
                        hasError: null,
                        isLoading: false,
                        data: _data
                    }
                })
            })
            .catch(error => {
                isMounted.current && setState(prev => {
                    return {
                        ...prev,
                        isLoading: false,
                        hasError: error
                    }
                })
                console.log(error)
                analytics.logError(error)
            })
    }

    useFocusEffect(
        useCallback(() => {

            analytics.logEvent('Viewed Categories', auth.getUserData.buyerData)
            analytics.googleHelpers.setCurrentScreen('ViewedCategories', 'ViewedCategories')

            loadData()

            return () => { }
        }, [])
    )


    return <>
        <View style={styles.container}>
            {
                // product_state.loading_next_category && !categories.length
                state.isLoading
                    ? <FlatList
                        initialNumToRender={10}
                        data={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                        renderItem={({ item, index }) => <GridView index={index} model={item} key={index} />}
                        keyExtractor={item => `${item}`}
                        key={3}
                        numColumns={3}
                        contentContainerStyle={styles.scrollView}
                    />
                    : state.hasError
                        ? <Text>{state.hasError?.message}</Text>
                        : <FlatList
                            initialNumToRender={10}
                            data={state.data}
                            renderItem={({ item, index }) => <GridView index={index} model={item} key={index} action={() => nav_handler(item)} />}
                            keyExtractor={item => `${item._id}`}
                            key={3}
                            numColumns={3}
                            contentContainerStyle={styles.scrollView}
                            onEndReached={() => {
                                loadData()
                            }}
                            onEndReachedThreshold={2}
                        />
            }
        </View>
    </>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.whiteColor,
    },
    scrollView: {
        backgroundColor: Colors.whiteColor,
    }
})

export default CategoryScreen
